
    import './styles.scoped.css';
    export default {
  "dimmed": "awsui_dimmed_10ipo_q6xwa_93",
  "marker": "awsui_marker_10ipo_q6xwa_144",
  "marker--line": "awsui_marker--line_10ipo_q6xwa_184",
  "marker--rectangle": "awsui_marker--rectangle_10ipo_q6xwa_188",
  "marker--hollow-rectangle": "awsui_marker--hollow-rectangle_10ipo_q6xwa_192",
  "marker--dashed": "awsui_marker--dashed_10ipo_q6xwa_204",
  "root": "awsui_root_10ipo_q6xwa_224",
  "value": "awsui_value_10ipo_q6xwa_259",
  "expandable": "awsui_expandable_10ipo_q6xwa_263",
  "list-item": "awsui_list-item_10ipo_q6xwa_267",
  "inner-list-item": "awsui_inner-list-item_10ipo_q6xwa_268",
  "key-value-pair": "awsui_key-value-pair_10ipo_q6xwa_273",
  "expandable-section": "awsui_expandable-section_10ipo_q6xwa_274",
  "key": "awsui_key_10ipo_q6xwa_273",
  "sub-items": "awsui_sub-items_10ipo_q6xwa_287",
  "list": "awsui_list_10ipo_q6xwa_267",
  "compact": "awsui_compact_10ipo_q6xwa_311",
  "with-sub-items": "awsui_with-sub-items_10ipo_q6xwa_316",
  "full-width": "awsui_full-width_10ipo_q6xwa_321",
  "announced": "awsui_announced_10ipo_q6xwa_325"
};
  